module.exports = __webpack_public_path__ + "static/media/trophy.ea7e515a.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/trophy.svg
 ** module id = 432
 ** module chunks = 0
 **/